import React, { useEffect } from 'react'
import { useSnackbar } from 'notistack'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import backgroundImage from '~/shared/assets/background/circle-participation.png'
import errorImage from '~/shared/assets/images/error.png'
import theme from '~/shared/styles/theme'

type Props = {
  children: React.ReactNode
}

function AuthRouter({ children }: Props) {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const location = useLocation()
  const session = localStorage.getItem('starlike-access-token')

  useEffect(() => {
    if (!session) {
      enqueueSnackbar('로그인이 필요합니다', { variant: 'error' })
    }
  }, [location, session, navigate])

  if (!session) {
    return (
      <Wrapper $backgroundImage={backgroundImage}>
        <ErrorImage src={errorImage} alt="error" />
        <Title>로그인이 필요합니다.</Title>
      </Wrapper>
    )
  }

  return <>{children}</>
}

export default AuthRouter

const Wrapper = styled.section<{
  $backgroundImage: string
}>`
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100vw;
  height: 100vh;
  min-height: 100vh;

  background-image: url(${backgroundImage});
  background-repeat: repeat repeat;
  background-size: 100vw auto;

  @media ${theme.device.medium} {
    width: 100%;
    height: auto;
  }
`

const ErrorImage = styled.img`
  width: 300px;
  margin-bottom: 40px;

  @media ${theme.device.medium} {
    width: 40%;
    height: auto;
  }
`

const Title = styled.h1`
  font-family: NanumSquareNeo-Heavy, sans-serif;
  font-size: 32px;
`
